import React, { useMemo, useRef } from 'react';

import CarouselReviewCard from '@rover/components/src/cards/CarouselReviewCard/';
import PaginationWrapper, {
  Props as PaginationWrapperProps,
} from '@rover/react-lib/src/components/lists/Carousel/PaginationWrapper';
import SnappingCarousel from '@rover/react-lib/src/components/lists/Carousel/SnappingCarousel';

type CarouselReviewCardProps = React.ComponentProps<typeof CarouselReviewCard>;

export type Review = CarouselReviewCardProps['review'] & {
  url: string;
  providerProfileUrl?: string;
};

type Props = {
  reviews: Review[];
  onCardViewed?: (index: number) => void;
  cardProps?: Omit<CarouselReviewCardProps, 'review' | 'rootCarouselRef' | 'onViewed'>;
  getCardHref?: (review: Review) => string | undefined;
} & Omit<PaginationWrapperProps, 'children'>;

const ReviewsCarousel: React.FC<Props> = ({
  reviews,
  onCardViewed,
  cardProps,
  getCardHref,
  ...props
}) => {
  const ref = useRef<HTMLDivElement | undefined>(undefined);

  const reviewCards = useMemo(
    () =>
      reviews.map((review, index) => (
        <CarouselReviewCard
          key={review.url}
          review={review}
          rootCarouselRef={ref}
          onViewed={onCardViewed ? () => onCardViewed(index) : undefined}
          {...cardProps}
          href={getCardHref ? getCardHref(review) : cardProps?.href}
        />
      )),
    [cardProps, getCardHref, onCardViewed, reviews]
  );

  return (
    <PaginationWrapper {...props}>
      <SnappingCarousel>{reviewCards}</SnappingCarousel>
    </PaginationWrapper>
  );
};

export default ReviewsCarousel;
